<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_ACCOUNT_BALANCE_PER_INVOICE' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      <astral-button variant="primary" size="small" type="button" icon="excel" labelKey="COMMON.EXCEL" (click)="exportExcel()"></astral-button>
    </div>
  </div>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls['companyId']" [itemsSource]="companies"></astral-select>
      <astral-date-picker [control]="form.controls['reconciliationDate']"></astral-date-picker>
      <app-autocomplete-remote
        [control]="form.controls['accountId']"
        [service]="accountAutoCompleteService"
        [defaultSearch]="'*'"
      ></app-autocomplete-remote>
      <astral-checkbox [control]="form.controls['ignoreRounding']"></astral-checkbox>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
    </div>
  </form>

  @if (dataContext) {
    <div>
      <div class="account-balance-sums-wrapper">
        <div class="account-balance-sums-wrapper__outline">
          @for (block of summaryBlocks; track block) {
            <div class="account-balance-sums-wrapper__block">
              <div class="account-balance-sums-wrapper__header">{{ block.label | translate }}</div>
              <div class="account-balance-sums-wrapper__value">
                @if (sums[block.available]) {
                  {{ sums[block.value] | money: false : null : sums[block.currency] }}
                } @else {
                  {{ 'ACCOUNT_BALANCE.DATA_NOT_AVAILABLE' | translate }}
                }
              </div>
            </div>
          }
        </div>
      </div>
      <app-expanded-list-view
        [columnDefinitions]="columnDefinitions"
        [itemsSource]="dataContext"
        [preferencesKey]="'report.account-balance-per-invoice.list'"
        (captionClick)="onInvoiceCaptionClicked($event)"
      ></app-expanded-list-view>
    </div>
  }
</section>
